import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@/ui';
import { MediaLibraryCore } from './MediaLibraryCore';
import { MediaItem } from './types';

export interface MediaLibraryModalProps {
  isOpen: boolean;
  toggle: () => void;
  onSelect?: (item: MediaItem) => void;
  selectedItem?: MediaItem | undefined;
  isSelectionMode?: boolean;
}

export const MediaLibraryModal: React.FC<MediaLibraryModalProps> = ({
  isOpen,
  toggle,
  onSelect,
  selectedItem,
  isSelectionMode = false,
}) => {
  const handleSelect = (item: MediaItem) => {
    if (onSelect) {
      onSelect(item);
      toggle();
    }
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} tone='info' size='xl'>
      <ModalHeader toggle={toggle}>{isSelectionMode ? 'Select Media' : 'Media Library'}</ModalHeader>
      <ModalBody>
        <MediaLibraryCore onSelect={handleSelect} selectedItem={selectedItem} isSelectionMode={isSelectionMode} />
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={toggle}>
          {isSelectionMode ? 'Cancel' : 'Close'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MediaLibraryModal;
